import axios from 'axios';

import envVar from '../config/envVars';

export interface RolloverUploadErrorItem {
  message: string;
  code: string;
  key: string;
  rowNumber: number;
  studentEmail?: string;
  enrollmentNo?: string;
  studentName?: string;
}

export interface RolloverUploadResponse {
  success: any[];
  errors: RolloverUploadErrorItem[];
}

export const uploadRolloverCsv = async (
  file: File,
  school: string
): Promise<RolloverUploadResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('school', school);
  const url = `${envVar.REACT_APP_BASE_API_URL}/users/roll-over`;
  const response = await axios.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response as unknown as RolloverUploadResponse;
};
